import { Header, Footer, PageHero, AboutBlock, WhyUsBlock, TrustBadges } from "@/components/site";

export default function AboutPage() {
  return (
    <div className="bg-white text-slate-800">
      <Header />
      <PageHero overline="About Us" title="About Segal Aurora Painters" subtitle="Aurora's trusted, fully-insured painting team — over 12 years transforming homes and businesses across the GTA." />
      <TrustBadges />
      <AboutBlock />
      <WhyUsBlock />
      <Footer />
    </div>
  );
}
